import React from "react";
import BlogList from "./BlogList";

function FlBlogList() {
  return <BlogList api={`${import.meta.env.VITE_BACKEND_URL}/edu/fl-blogs`} />;
}

export default FlBlogList;
